module.exports = "images/enfants_5.cf1c8db1.png";